import { Stack } from 'component-library';
import { FC, HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import { CONTACT_SUPPORT_EMAIL_ADDRESS } from '@/config/constants';

import { Card } from '../card/Card';

export const Help: FC<HTMLAttributes<HTMLDivElement>> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <Card label={t('landSteward.portfolio.help.label')} data-testid='portfolio-help' className={className}>
      <Stack spacing={6} className='items-start'>
        <span className='typography-body1 whitespace-pre-wrap'>
          {t('landSteward.portfolio.help.text', {
            email: CONTACT_SUPPORT_EMAIL_ADDRESS,
          })}
        </span>
      </Stack>
    </Card>
  );
};
